import { Injectable } from '@angular/core';
import { GlobalSelectionControlService } from '../map/services/global-selection-control.service';
import { MenuManagementService } from '../menu/services/menu-management.service';
import { SearchItem } from '../models/searchItem';
import { CalculationsService } from './calculations.service';
import { CrossSectionService } from './cross-section.service';
import { SearchService } from './search.service';
import { ToolsControlService } from './tools-control.service';

@Injectable({
  providedIn: 'root'
})
export class GenericComponentControlService {

  active : boolean;
  windowName : string;
  fullScreenMode : boolean = false;

  constructor(private menuService: MenuManagementService,
    private searchService: SearchService,
    private toolsService: ToolsControlService,
    private calculationService: CalculationsService,
    private crossSectionController: CrossSectionService) {
  }

  openGenericWindow(name: string) : void {
    this.active = !this.active;
    this.windowName = name;
    //this.menuService.toogleMenu();
    this.toolsService.navigationOnTop = true;
  }
}
